import React, {useEffect, useImperativeHandle, useState} from "react";
import {
TabsProps,
} from "antd";

import { Tabs} from "components/common";

import {useAppDispatch, useAppSelector} from "../../../../../../redux/hooks";

import {tabKeys} from "../../../../../../types/enums";
import License from "../../../EmployeeDirectory/components/License/License";
import Tab1 from "./Tab1/Tab1";
import Tab2 from "./Tab2/Tab2";
import Tab3 from "./Tab3/Tab3";


const FormEdit = props => {
  const {data, closeModal, type, getListApi, setCurrentPage} = props;
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((state) => state.common.activeTab);


  useEffect(() => {

  }, []);



  const items: TabsProps["items"] = [
    {
      key: tabKeys.CANDIDATES.TAB_1,
      label: `Thông tin ứng viên `,
      children: <Tab1
          data={data}
          getListApi={getListApi}
          type={type}
          setCurrentPage={null}
          closeModal={closeModal}/>,
    },
    {
      key: tabKeys.CANDIDATES.TAB_2,
      label: `Lịch phỏng vấn`,
      children: <Tab2
          data={data}
          getListApi={getListApi}
          type={type}
          setCurrentPage={null}
          closeModal={closeModal}/>,
    },
    {
      key: tabKeys.CANDIDATES.TAB_3,
      label: `Đánh giá kết quả tuyển dụng `,
      children: <Tab3
          data={data}
          getListApi={getListApi}
          type={type}
          setCurrentPage={null}
          closeModal={closeModal}/>,
    },

  ];

  return (
      <div className="employee-directory page">
        <div className="main">
          <Tabs activeKey={activeTab} items={items}/>
        </div>
      </div>
  );
};
export default FormEdit;
